import * as actions from './actions'

const MedicalRecordStore = {
  namespaced: true,
  state: {},
  actions
}

export default MedicalRecordStore
